import T from "@marginly/ui/components/typography";
import styled from "styled-components";

export const ReferralContainer = styled.div`
  background: #defffa;
  width: 100%;
  border-radius: 24px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  font-size: 16px;
  display: grid;
  grid-template-areas:
    "label button"
    "url button";
  row-gap: 0;
  height: 80px;
  &.borders-sm {
    border-radius: 16px;
  }
`;

export const ReferralLabel = styled.div`
  grid-area: label;
  text-align: left;
  font-size: 12px;
  letter-spacing: 0.5px;
  color: rgba(66, 61, 60, 0.64);
`;

export const ReferralUrl = styled.div`
  grid-area: url;
  color: #000;
  overflow: auto;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-align: left;
`;

export const ReferralCopyButton = styled(T)`
  cursor: pointer;
  grid-area: button;
  outline: none;
  background-color: transparent;
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.48px;
  margin-left: auto;
  padding: 4px 12px;
  border-radius: 16px;
  transition: 300ms ease-out;
  height: 32px;

  &:hover {
    background: rgba(204, 187, 184, 0.16);
  }
`;

export const Notification = styled.div`
  position: fixed;
  left: 50%;
  top: 24px;
  transform: translateX(-50%);
  background: #000000;
  border-radius: 24px;
  color: #fff;
  padding: 16px;
  display: flex;
  align-items: center;
  z-index: 2000;
  gap: 16px;
  width: 462px;
  max-width: calc(100% - 32px);
  opacity: 0;
  visibility: hidden;
  transition: 200ms ease-out;
  img {
    width: 64px;
    height: 64px;
  }
  &.shown {
    visibility: visible;
    opacity: 1;
  }
`;
